export const SET_FLAGS = 'flags/SET_FLAGS';

export const setFlags = flags => ({
  type: SET_FLAGS,
  flags,
});
